export interface DeleteFollowUpFormDto {
  reason: string;
}

export const createDeleteFollowUpFormDto = (): DeleteFollowUpFormDto => {
  return { reason: "" };
};
